document.querySelectorAll('[data-auto-submit]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
document.querySelectorAll('[data-variant-select]').forEach(select => {
  const update = () => {
    const option = select.selectedOptions[0];
    const price = document.querySelector('[data-product-price]');
    const button = select.form.querySelector('[data-add-button]');
    if (price) price.textContent = option.dataset.price;
    if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? document.body.dataset.soldLabel : document.body.dataset.addLabel; }
    const url = new URL(window.location.href); url.searchParams.set('variant', select.value); history.replaceState(null, '', url);
  };
  select.addEventListener('change', update);
});
document.addEventListener('keydown', event => { if (event.key === 'Escape') document.querySelectorAll('.mobile-menu[open]').forEach(menu => menu.removeAttribute('open')); });
document.addEventListener('click', event => { document.querySelectorAll('.mobile-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.removeAttribute('open'); }); });

// Desktop pointer hover and keyboard/click dropdown support.
document.querySelectorAll('.desktop-nav .nav-dropdown').forEach(dropdown => {
  let closeTimeout;
  dropdown.addEventListener('mouseenter', () => { clearTimeout(closeTimeout); dropdown.open = true; });
  dropdown.addEventListener('mouseleave', () => { closeTimeout = setTimeout(() => { if (!dropdown.contains(document.activeElement)) dropdown.open = false; }, 180); });
  dropdown.addEventListener('keydown', event => { if (event.key === 'Escape') { dropdown.open = false; dropdown.querySelector('summary')?.focus(); } });
});
document.addEventListener('click', event => {
  document.querySelectorAll('.desktop-nav .nav-dropdown[open]').forEach(dropdown => { if (!dropdown.contains(event.target)) dropdown.open = false; });
});
